import { TAB } from '~/constants/Tab';

/**
 * Remove outdated default filter groups from the list of filter groups.
 * If a filter group with a name similar to one of the default filter groups is found but it doesn't have the correct stable UUID, it should be removed because it's outdated.
 * See https://linear.app/vestigas/issue/VGS-7335/handle-misspelled-nicht-zugeordnet-filter
 * While changing the filters from frontend to backend, some leftovers need to be cleaned up.
 * TODO: This can be removed again once all filter groups are cleaned up in the backend via migration (around March 2025?).
 */
export const withoutOutdatedDefaultFilterGroups = (filterGroup) => {
  if (
    filterGroup.name.toLowerCase() ===
      TAB.DELIVERY.CHANGES.NAME.toLowerCase() &&
    filterGroup.id !== TAB.DELIVERY.CHANGES.ID
  ) {
    return null;
  }

  if (
    filterGroup.name.toLowerCase() ===
      TAB.DELIVERY.UNASSIGNED_DELIVERY_NOTES.NAME.toLowerCase() &&
    filterGroup.id !== TAB.DELIVERY.UNASSIGNED_DELIVERY_NOTES.ID
  ) {
    return null;
  }

  return filterGroup;
};
